<template>
  <footer class="footer">
    <div class="container footer-content">
      <div class="footer-brand">
        <IconSvg name="shield" class="footer-icon" />
        <span>Dragon Ops</span>
      </div>
      <div class="footer-links">
        <a v-for="link in footerLinks" :key="link" href="#">{{ link }}</a>
      </div>
      <p class="copyright">{{ t('footer.copyright') }}</p>
    </div>
  </footer>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import IconSvg from './IconSvg.vue'

const { t, tm } = useI18n()
const footerLinks = computed(() => tm('footer.links'))
</script>

<style scoped>
.footer {
  background: #120404;
  color: rgba(255,255,255,0.6);
  padding: 2.5rem 0;
  border-top: 1px solid rgba(255,255,255,0.08);
}
.footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}
.footer-brand {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #fff;
  font-weight: 700;
  font-size: 1.2rem;
}
.footer-icon {
  width: 26px;
  height: 26px;
  color: #60a5fa;
}
.footer-links {
  display: flex;
  gap: 1.5rem;
  flex-wrap: wrap;
  justify-content: center;
}
.footer-links a {
  color: rgba(255,255,255,0.6);
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.2s;
}
.footer-links a:hover {
  color: #fff;
}
.copyright {
  font-size: 0.85rem;
  margin: 0;
}
</style>
